import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';
import { PAGES_METADATA } from 'shared/custom/constants/commonConstants';

export const getCustomPage = (props: IncomingContent): Layout => ({
	name: 'CustomStack',
	metadata: PAGES_METADATA.HOMEPAGE,
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: getContentItemForSlot(props, 'first'),
		second: getContentItemForSlot(props, 'second'),
		third: getContentItemForSlot(props, 'third'),
		fourth: getContentItemForSlot(props, 'fourth'),
		fifth: getContentItemForSlot(props, 'fifth'),
		sixth: getContentItemForSlot(props, 'sixth'),
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
